import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { artikelGruppenByNrSelector, artikelGruppenSelector } from 'store/lookups/selector';

interface ArtikelGruppeByNrProps {
    label: string;
    disabled: boolean;
    value: number | null;
    menuPlacement?: MenuPlacement;
    includeArchiv?: boolean;
    allowEmpty?: boolean;
    renderLabel?: 'label' | 'placeholder' | 'no';
    onChange: (newValue: number) => void;
}

export const ArtikelGruppeByNr: React.FC<ArtikelGruppeByNrProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'bottom',
    includeArchiv = true,
    allowEmpty = false,
    renderLabel = 'label',
    onChange,
}) => {
    const artikelGruppen = useSelector(artikelGruppenSelector);
    const artikelGruppenByNr = useSelector(artikelGruppenByNrSelector);

    const options = React.useMemo(() => {
        const o = artikelGruppen
            .filter((a) => includeArchiv || a.activeCount > 0)
            .sort((a, b) => a.text.localeCompare(b.text))
            .map((ag) => ({
                value: ag.nr.toString(),
                label: ag.text,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [artikelGruppen, allowEmpty, includeArchiv]);

    return (
        <>
            {renderLabel === 'label' && <Label>{label}</Label>}
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: artikelGruppenByNr[value]?.text || value.toString(),
                          }
                        : null
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value ? parseInt(option?.value, 10) || 0 : 0);
                }}
                placeholder={renderLabel === 'placeholder' ? 'Artikelgruppe' : ''}
            />
        </>
    );
};
